module.exports = __webpack_public_path__ + "static/wave_footer-364368ebd32759e0e65d876f05ee09f0.png";